module.exports = __webpack_public_path__ + "img/image8.9d73d22f.png";